<template>
	<div class="footer" :class="{ 'gray': gray }">
		<div class="top" :class="{ fixed: isFixed }">
			<span class="top_item" @click="hFootClick(0)">{{ $t('nav.home') }}</span>
			<span class="top_item" @click="hFootClick(1)">{{ $t('nav.about') }}</span>
			<span class="top_item" @click="hFootClick(2)">{{ $t('nav.project') }}</span>
			<span class="top_item" @click="hFootClick(3)">{{ $t('nav.contact') }}</span>
		</div>
		<div class="bottom">
			Copyright © Bitfeifan Technology Company INC
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'Footer',
	props: {
		isFixed: Boolean
	},
	data() {
		return {

		}
	},
	computed: {
		...mapState(['gray'])
	},
	methods: {
		hFootClick(index) {
			this.$emit('click', index)
		}
	}
}
</script>

<style scoped="scoped">
/* .footer {} */

.footer .top {
	padding: 1rem 0;
	background-color: #333434;
	display: flex;
	justify-content: center;
}

.footer .top.fixed {
	max-width: 100%;
	position: fixed;
	bottom: 0;
	z-index: 99999;
}

.footer .bottom {
	background-color: #414141;
	padding: 30px 0 35px;
}

.footer .top_item {
	text-align: center;
	display: inline-block;
	width: 10.75rem;
	border-left: 1px solid #4A4B4B;
	cursor: pointer;
}

.footer .top_item:last-child {
	border-right: 1px solid #4A4B4B;
}

@media screen and (max-width : 480px) {
	.footer .bottom {
		margin-bottom: 1.25rem;
	}
}
</style>
